// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.square-grid-chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  width: 60vw;
  max-width: 1200px;
  margin: 0 auto;
}

.chart-header {
  text-align: center;
  margin-bottom: 25px;
  width: 100%;
}

.chart-header h3 {
  color: #333;
  font-size: 22px;
  margin: 0 0 10px 0;
}

.language-and-print-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.chart-info {
  color: #666;
  font-size: 13px;
  margin: 5px 0;
  line-height: 1.4;
}

.ascendant-info {
  color: #667eea;
  font-size: 14px;
  font-weight: 600;
  margin: 8px 0 0 0;
}

.moon-star-info {
  color: #764ba2;
  font-size: 13px;
  font-weight: 600;
  margin: 6px 0 0 0;
  padding: 8px 12px;
  background: rgba(118, 75, 162, 0.08);
  border-left: 3px solid #764ba2;
  border-radius: 4px;
}

/* Language Selector */
.language-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  padding: 0;
  background: transparent;
  border-radius: 0;
  border: none;
}

.language-selector label {
  font-weight: 600;
  color: #333;
  font-size: 12px;
  white-space: nowrap;
}

.language-dropdown {
  padding: 7px 10px;
  border: 2px solid #667eea;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #667eea;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.language-dropdown:hover {
  background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
  border-color: #764ba2;
}

.language-dropdown:focus {
  outline: none;
  border-color: #764ba2;
  box-shadow: 0 0 8px rgba(102, 126, 234, 0.3);
}

.print-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.print-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.print-btn:active {
  transform: translateY(0);
}

.print-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Action Buttons Container */
.chart-action-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

/* Save Button */
.save-btn {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.save-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
}

.save-btn:active:not(:disabled) {
  transform: translateY(0);
}

.save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Save Message */
.save-message {
  margin-top: 12px;
  padding: 12px 16px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  animation: slideDown 0.3s ease-out;
}

.save-message.success {
  background: rgba(76, 175, 80, 0.1);
  color: #2e7d32;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.save-message.error {
  background: rgba(244, 67, 54, 0.1);
  color: #c62828;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.chart-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #f5f5f5 0%, #fafafa 100%);
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e0e0e0;
  width: 100%;
  overflow-x: auto;
}

.square-grid-chart {
  max-width: 100%;
  height: auto;
  min-width: 400px;
}

.house-number {
  font-family: 'Arial', sans-serif;
  letter-spacing: 0.05em;
}

.zodiac-sign {
  font-family: 'Arial', sans-serif;
  letter-spacing: 0.05em;
}

/* Planet legend */
.planet-legend {
  width: 100%;
  background: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  
}

.planet-legend h4 {
  color: #333;
  font-size: 16px;
  margin: 0 0 15px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.legend-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: white;
  border-radius: 5px;
  border-left: 4px solid #667eea;
}

.legend-color {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.legend-text {
  color: #555;
  font-size: 11px;
  font-weight: 500;
}

/* Planet Details Table Styling */
.planet-details-section {
  width: 100%;
  margin-top: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #f9f9fb 100%);
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.planet-details-section h4 {
  color: #333;
  font-size: 16px;
  margin: 0 0 20px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
}

.planet-table-wrapper {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #d0d0d0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.planet-details-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-size: 12px;
}

.planet-details-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
}

.planet-details-table thead th {
  padding: 14px 10px;
  text-align: left;
  border: 1px solid #5a6fd4;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.planet-details-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s ease;
}

.planet-details-table tbody tr:hover {
  background-color: #f9f9fb;
}

.planet-details-table tbody td {
  padding: 12px 10px;
  border: 1px solid #e0e0e0;
  color: #555;
}

.planet-details-table tbody tr:nth-child(odd) {
  background-color: #fafbfc;
}

.planet-details-table tbody tr:nth-child(even) {
  background-color: white;
}

.house-cell {
  background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
  font-weight: 600;
  color: #667eea;
  text-align: center;
  width: 50px;
  min-width: 50px;
}

.planet-name-cell {
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

.planet-color-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.sign-cell {
  font-weight: 500;
  color: #667eea;
}

.degrees-cell,
.minutes-cell {
  text-align: right;
  font-family: 'Courier New', monospace;
  color: #666;
}

.star-cell,
.star-planet-cell,
.pada-cell {
  color: #666;
  font-size: 11px;
}

.star-cell {
  color: #E67E22;
  font-weight: 500;
}

.pada-cell {
  color: #C0392B;
  font-weight: 500;
}

.empty-house-row td {
  padding: 12px 10px;
  text-align: center;
  color: #999;
  font-style: italic;
  background-color: #fafafa;
}

.empty-house-text {
  color: #999 !important;
}

/* Table Notes/Legend */
.table-notes {
  margin-top: 20px;
  padding: 15px;
  background: white;
  border-radius: 6px;
  border-left: 4px solid #667eea;
}

.table-notes p {
  margin: 0 0 10px 0;
  color: #333;
  font-weight: 600;
  font-size: 13px;
}

.table-notes ul {
  margin: 0;
  padding-left: 20px;
  list-style-type: none;
}

.table-notes li {
  color: #666;
  font-size: 11px;
  margin: 6px 0;
  line-height: 1.5;
}

.table-notes strong {
  color: #333;
}

/* Responsive design */
@media (max-width: 768px) {
  .square-grid-chart-container {
    padding: 20px;
    max-width: 100%;
  }

  .language-and-print-row {
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }

  .language-selector {
    width: 100%;
  }

  .chart-action-buttons {
    width: 100%;
    gap: 8px;
  }

  .save-btn,
  .print-btn {
    width: 100%;
    flex: 1 1;
  }

  .chart-header h3 {
    font-size: 20px;
  }

  .square-grid-chart {
    min-width: 300px;
  }

  .legend-content {
    grid-template-columns: 1fr;
  }

      .legend-item {
    padding: 8px;
    font-size: 12px;
  }

  .legend-text {
    font-size: 12px;
  }

  /* Responsive table on tablet */
  .planet-details-table {
    font-size: 11px;
  }

  .planet-details-table thead th {
    padding: 10px 8px;
    font-size: 11px;
  }

  .planet-details-table tbody td {
    padding: 10px 8px;
    font-size: 11px;
  }

  .table-notes {
    font-size: 12px;
  }

  .table-notes li {
    font-size: 11px;
  }

  /* Responsive language selector on tablet */
  .language-selector {
    padding: 8px;
    gap: 8px;
  }

  .language-selector label {
    font-size: 12px;
  }

  .language-dropdown {
    padding: 6px 10px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .square-grid-chart-container {
    padding: 15px;
  }

  .chart-header h3 {
    font-size: 18px;
  }

  .chart-wrapper {
    padding: 10px;
  }

  .square-grid-chart {
    min-width: 250px;
  }

  /* Mobile table styling */
  .planet-details-section {
    padding: 15px;
  }

  .planet-details-section h4 {
    font-size: 14px;
  }

  .planet-table-wrapper {
    border-radius: 6px;
  }

  .planet-details-table {
    font-size: 9px;
  }

  .planet-details-table thead th {
    padding: 8px 4px;
    font-size: 9px;
  }

  .planet-details-table tbody td {
    padding: 6px 4px;
    font-size: 9px;
  }

  .planet-color-dot {
    width: 10px;
    height: 10px;
  }

  .table-notes {
    padding: 12px;
    font-size: 11px;
    margin-top: 15px;
  }

  .table-notes p {
    font-size: 11px;
    margin: 0 0 8px 0;
  }

  .table-notes li {
    font-size: 9px;
    margin: 4px 0;
  }

  /* Mobile language selector */
  .language-selector {
    padding: 8px;
    gap: 6px;
    flex-wrap: wrap;
  }

  .language-selector label {
    font-size: 11px;
  }

  .language-dropdown {
    padding: 6px 10px;
    font-size: 11px;
  }
}

/* Print styles */
@media print {
  body {
    margin: 0;
    padding: 0;
  }

  .square-grid-chart-container {
    box-shadow: none;
    border: 1px solid #999;
    max-width: 100%;
    padding: 20px;
    background: white;
    page-break-after: avoid;
  }

  .chart-header {
    page-break-after: avoid;
  }

  .print-btn {
    display: none;
  }

  .chart-wrapper {
    background: white;
    border: 1px solid #999;
    page-break-inside: avoid;
  }

  .square-grid-chart {
    max-width: 100%;
    height: auto;
  }

  .planet-legend {
    page-break-inside: avoid;
    background: white;
    border: 1px solid #999;
  }

  .legend-item {
    page-break-inside: avoid;
    background: white;
    border: 1px solid #e0e0e0;
  }

  /* Make text more readable for print */
  .chart-header h3 {
    font-size: 18px;
    color: #000;
  }

  .chart-info,
  .ascendant-info {
    color: #000;
    font-size: 11px;
  }

  .legend-text {
    color: #000;
    font-size: 11px;
  }

  /* Print styles for planet details table */
  .planet-details-section {
    page-break-inside: avoid;
    background: white;
    border: 1px solid #999;
  }

  .planet-details-section h4 {
    color: #000;
    font-size: 14px;
  }

  .planet-details-table {
    font-size: 9px;
    border-collapse: collapse;
  }

  .planet-details-table thead {
    background: white;
    color: #000;
    border-bottom: 2px solid #000;
  }

  .planet-details-table thead th {
    border: 1px solid #000;
    padding: 8px;
    color: #000;
    font-weight: 700;
    text-align: left;
  }

  .planet-details-table tbody td {
    border: 1px solid #999;
    padding: 8px;
    color: #000;
  }

  .planet-details-table tbody tr:nth-child(odd) {
    background-color: white;
  }

  .planet-details-table tbody tr:nth-child(even) {
    background-color: white;
  }

  .house-cell {
    background: white;
    color: #000;
    font-weight: 700;
    border: 1px solid #000;
  }

  .planet-name-cell,
  .sign-cell {
    color: #000;
  }

  .star-cell,
  .pada-cell {
    color: #000;
  }

  .empty-house-row td {
    background-color: white;
    color: #000;
  }

  .table-notes {
    page-break-inside: avoid;
    background: white;
    border: 1px solid #999;
  }

  .table-notes p,
  .table-notes li {
    color: #000;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SquareGridChart.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iEAAiE;EACjE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;;AAE3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iEAAiE;EACjE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,qCAAqC;EACrC,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,SAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;MAEI;IACF,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA,6BAA6B;EAC7B;IACE,YAAY;IACZ,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA,0CAA0C;EAC1C;IACE,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".square-grid-chart-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  width: 60vw;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.chart-header {\n  text-align: center;\n  margin-bottom: 25px;\n  width: 100%;\n}\n\n.chart-header h3 {\n  color: #333;\n  font-size: 22px;\n  margin: 0 0 10px 0;\n}\n\n.language-and-print-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  margin-top: 12px;\n  flex-wrap: wrap;\n}\n\n.chart-info {\n  color: #666;\n  font-size: 13px;\n  margin: 5px 0;\n  line-height: 1.4;\n}\n\n.ascendant-info {\n  color: #667eea;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 8px 0 0 0;\n}\n\n.moon-star-info {\n  color: #764ba2;\n  font-size: 13px;\n  font-weight: 600;\n  margin: 6px 0 0 0;\n  padding: 8px 12px;\n  background: rgba(118, 75, 162, 0.08);\n  border-left: 3px solid #764ba2;\n  border-radius: 4px;\n}\n\n/* Language Selector */\n.language-selector {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  border-radius: 0;\n  border: none;\n}\n\n.language-selector label {\n  font-weight: 600;\n  color: #333;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.language-dropdown {\n  padding: 7px 10px;\n  border: 2px solid #667eea;\n  border-radius: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #667eea;\n  background: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.language-dropdown:hover {\n  background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);\n  border-color: #764ba2;\n}\n\n.language-dropdown:focus {\n  outline: none;\n  border-color: #764ba2;\n  box-shadow: 0 0 8px rgba(102, 126, 234, 0.3);\n}\n\n.print-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 5px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.print-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.print-btn:active {\n  transform: translateY(0);\n}\n\n.print-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Action Buttons Container */\n.chart-action-buttons {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n/* Save Button */\n.save-btn {\n  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 5px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);\n}\n\n.save-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);\n}\n\n.save-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.save-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Save Message */\n.save-message {\n  margin-top: 12px;\n  padding: 12px 16px;\n  border-radius: 5px;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n  animation: slideDown 0.3s ease-out;\n}\n\n.save-message.success {\n  background: rgba(76, 175, 80, 0.1);\n  color: #2e7d32;\n  border: 1px solid rgba(76, 175, 80, 0.3);\n}\n\n.save-message.error {\n  background: rgba(244, 67, 54, 0.1);\n  color: #c62828;\n  border: 1px solid rgba(244, 67, 54, 0.3);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.chart-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 30px;\n  background: linear-gradient(135deg, #f5f5f5 0%, #fafafa 100%);\n  padding: 20px;\n  border-radius: 8px;\n  border: 2px solid #e0e0e0;\n  width: 100%;\n  overflow-x: auto;\n}\n\n.square-grid-chart {\n  max-width: 100%;\n  height: auto;\n  min-width: 400px;\n}\n\n.house-number {\n  font-family: 'Arial', sans-serif;\n  letter-spacing: 0.05em;\n}\n\n.zodiac-sign {\n  font-family: 'Arial', sans-serif;\n  letter-spacing: 0.05em;\n}\n\n/* Planet legend */\n.planet-legend {\n  width: 100%;\n  background: #f9f9f9;\n  padding: 20px;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  \n}\n\n.planet-legend h4 {\n  color: #333;\n  font-size: 16px;\n  margin: 0 0 15px 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.legend-content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 12px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  background: white;\n  border-radius: 5px;\n  border-left: 4px solid #667eea;\n}\n\n.legend-color {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.legend-text {\n  color: #555;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n/* Planet Details Table Styling */\n.planet-details-section {\n  width: 100%;\n  margin-top: 30px;\n  padding: 20px;\n  background: linear-gradient(135deg, #f5f7fa 0%, #f9f9fb 100%);\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n}\n\n.planet-details-section h4 {\n  color: #333;\n  font-size: 16px;\n  margin: 0 0 20px 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  text-align: center;\n}\n\n.planet-table-wrapper {\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 1px solid #d0d0d0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.planet-details-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  font-size: 12px;\n}\n\n.planet-details-table thead {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  font-weight: 600;\n}\n\n.planet-details-table thead th {\n  padding: 14px 10px;\n  text-align: left;\n  border: 1px solid #5a6fd4;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.planet-details-table tbody tr {\n  border-bottom: 1px solid #e0e0e0;\n  transition: background-color 0.2s ease;\n}\n\n.planet-details-table tbody tr:hover {\n  background-color: #f9f9fb;\n}\n\n.planet-details-table tbody td {\n  padding: 12px 10px;\n  border: 1px solid #e0e0e0;\n  color: #555;\n}\n\n.planet-details-table tbody tr:nth-child(odd) {\n  background-color: #fafbfc;\n}\n\n.planet-details-table tbody tr:nth-child(even) {\n  background-color: white;\n}\n\n.house-cell {\n  background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);\n  font-weight: 600;\n  color: #667eea;\n  text-align: center;\n  width: 50px;\n  min-width: 50px;\n}\n\n.planet-name-cell {\n  font-weight: 600;\n  color: #333;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.planet-color-dot {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.sign-cell {\n  font-weight: 500;\n  color: #667eea;\n}\n\n.degrees-cell,\n.minutes-cell {\n  text-align: right;\n  font-family: 'Courier New', monospace;\n  color: #666;\n}\n\n.star-cell,\n.star-planet-cell,\n.pada-cell {\n  color: #666;\n  font-size: 11px;\n}\n\n.star-cell {\n  color: #E67E22;\n  font-weight: 500;\n}\n\n.pada-cell {\n  color: #C0392B;\n  font-weight: 500;\n}\n\n.empty-house-row td {\n  padding: 12px 10px;\n  text-align: center;\n  color: #999;\n  font-style: italic;\n  background-color: #fafafa;\n}\n\n.empty-house-text {\n  color: #999 !important;\n}\n\n/* Table Notes/Legend */\n.table-notes {\n  margin-top: 20px;\n  padding: 15px;\n  background: white;\n  border-radius: 6px;\n  border-left: 4px solid #667eea;\n}\n\n.table-notes p {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.table-notes ul {\n  margin: 0;\n  padding-left: 20px;\n  list-style-type: none;\n}\n\n.table-notes li {\n  color: #666;\n  font-size: 11px;\n  margin: 6px 0;\n  line-height: 1.5;\n}\n\n.table-notes strong {\n  color: #333;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .square-grid-chart-container {\n    padding: 20px;\n    max-width: 100%;\n  }\n\n  .language-and-print-row {\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n  }\n\n  .language-selector {\n    width: 100%;\n  }\n\n  .chart-action-buttons {\n    width: 100%;\n    gap: 8px;\n  }\n\n  .save-btn,\n  .print-btn {\n    width: 100%;\n    flex: 1;\n  }\n\n  .chart-header h3 {\n    font-size: 20px;\n  }\n\n  .square-grid-chart {\n    min-width: 300px;\n  }\n\n  .legend-content {\n    grid-template-columns: 1fr;\n  }\n\n      .legend-item {\n    padding: 8px;\n    font-size: 12px;\n  }\n\n  .legend-text {\n    font-size: 12px;\n  }\n\n  /* Responsive table on tablet */\n  .planet-details-table {\n    font-size: 11px;\n  }\n\n  .planet-details-table thead th {\n    padding: 10px 8px;\n    font-size: 11px;\n  }\n\n  .planet-details-table tbody td {\n    padding: 10px 8px;\n    font-size: 11px;\n  }\n\n  .table-notes {\n    font-size: 12px;\n  }\n\n  .table-notes li {\n    font-size: 11px;\n  }\n\n  /* Responsive language selector on tablet */\n  .language-selector {\n    padding: 8px;\n    gap: 8px;\n  }\n\n  .language-selector label {\n    font-size: 12px;\n  }\n\n  .language-dropdown {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .square-grid-chart-container {\n    padding: 15px;\n  }\n\n  .chart-header h3 {\n    font-size: 18px;\n  }\n\n  .chart-wrapper {\n    padding: 10px;\n  }\n\n  .square-grid-chart {\n    min-width: 250px;\n  }\n\n  /* Mobile table styling */\n  .planet-details-section {\n    padding: 15px;\n  }\n\n  .planet-details-section h4 {\n    font-size: 14px;\n  }\n\n  .planet-table-wrapper {\n    border-radius: 6px;\n  }\n\n  .planet-details-table {\n    font-size: 9px;\n  }\n\n  .planet-details-table thead th {\n    padding: 8px 4px;\n    font-size: 9px;\n  }\n\n  .planet-details-table tbody td {\n    padding: 6px 4px;\n    font-size: 9px;\n  }\n\n  .planet-color-dot {\n    width: 10px;\n    height: 10px;\n  }\n\n  .table-notes {\n    padding: 12px;\n    font-size: 11px;\n    margin-top: 15px;\n  }\n\n  .table-notes p {\n    font-size: 11px;\n    margin: 0 0 8px 0;\n  }\n\n  .table-notes li {\n    font-size: 9px;\n    margin: 4px 0;\n  }\n\n  /* Mobile language selector */\n  .language-selector {\n    padding: 8px;\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n\n  .language-selector label {\n    font-size: 11px;\n  }\n\n  .language-dropdown {\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n}\n\n/* Print styles */\n@media print {\n  body {\n    margin: 0;\n    padding: 0;\n  }\n\n  .square-grid-chart-container {\n    box-shadow: none;\n    border: 1px solid #999;\n    max-width: 100%;\n    padding: 20px;\n    background: white;\n    page-break-after: avoid;\n  }\n\n  .chart-header {\n    page-break-after: avoid;\n  }\n\n  .print-btn {\n    display: none;\n  }\n\n  .chart-wrapper {\n    background: white;\n    border: 1px solid #999;\n    page-break-inside: avoid;\n  }\n\n  .square-grid-chart {\n    max-width: 100%;\n    height: auto;\n  }\n\n  .planet-legend {\n    page-break-inside: avoid;\n    background: white;\n    border: 1px solid #999;\n  }\n\n  .legend-item {\n    page-break-inside: avoid;\n    background: white;\n    border: 1px solid #e0e0e0;\n  }\n\n  /* Make text more readable for print */\n  .chart-header h3 {\n    font-size: 18px;\n    color: #000;\n  }\n\n  .chart-info,\n  .ascendant-info {\n    color: #000;\n    font-size: 11px;\n  }\n\n  .legend-text {\n    color: #000;\n    font-size: 11px;\n  }\n\n  /* Print styles for planet details table */\n  .planet-details-section {\n    page-break-inside: avoid;\n    background: white;\n    border: 1px solid #999;\n  }\n\n  .planet-details-section h4 {\n    color: #000;\n    font-size: 14px;\n  }\n\n  .planet-details-table {\n    font-size: 9px;\n    border-collapse: collapse;\n  }\n\n  .planet-details-table thead {\n    background: white;\n    color: #000;\n    border-bottom: 2px solid #000;\n  }\n\n  .planet-details-table thead th {\n    border: 1px solid #000;\n    padding: 8px;\n    color: #000;\n    font-weight: 700;\n    text-align: left;\n  }\n\n  .planet-details-table tbody td {\n    border: 1px solid #999;\n    padding: 8px;\n    color: #000;\n  }\n\n  .planet-details-table tbody tr:nth-child(odd) {\n    background-color: white;\n  }\n\n  .planet-details-table tbody tr:nth-child(even) {\n    background-color: white;\n  }\n\n  .house-cell {\n    background: white;\n    color: #000;\n    font-weight: 700;\n    border: 1px solid #000;\n  }\n\n  .planet-name-cell,\n  .sign-cell {\n    color: #000;\n  }\n\n  .star-cell,\n  .pada-cell {\n    color: #000;\n  }\n\n  .empty-house-row td {\n    background-color: white;\n    color: #000;\n  }\n\n  .table-notes {\n    page-break-inside: avoid;\n    background: white;\n    border: 1px solid #999;\n  }\n\n  .table-notes p,\n  .table-notes li {\n    color: #000;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
